{% block sw_cms_block_acris_blog_content %}
    <div class="sw-cms-preview-acris-blog-content">
        {{ $t('acris-blog.elements.blogContent.preview.content') }}
    </div>
{% endblock %}
